import { AnalysisFileType } from "../../../types/analysisFileTypes";
import { SidebarLinkPathTypes, SidebarLinkTypes } from "../../../scaffold/ui/LinkTypes";
import GenericAnalysisFilesAdminPage from "./GenericAnalysisFileAdminPage";


export default function CompanyPensionAnalysisFilesAdminPage() {
    return <GenericAnalysisFilesAdminPage
        fileType={AnalysisFileType.CompanyPensionAnalysisFile}
        title={SidebarLinkTypes.superAdminAnalysisFilesCompanyPension}
        link={SidebarLinkPathTypes.superAdminAnalysisFilesCompanyPension}
    />
}